import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentUpdateAction from './equipmentUpdate.action.json' with { type: 'json' }
import { equipmentObject } from '../equipmentObject'

const equipmentUpdateDefinition = defineAction({
  ...equipmentUpdateAction,
  input: equipmentObject
    .pick({
      id: true,
      title: true,
      type: true,
      plate: true,
      patrimonyNumber: true,
      observation: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default equipmentUpdateDefinition
